<template>
  <banners>
    <div class="mx-auto max-w-screen-lg px-4 py-4 md:px-10">
      <h1 class="my-3 text-left text-2xl text-dark-blue md:my-6">
        Add Carriers
      </h1>
      <div
        class="flex flex-col md:rounded-md md:border md:border-light-gray md:p-8 md:shadow-primary"
      >
        <h2 class="my-3 text-left text-1lg text-dark-blue">Carrier Details</h2>
        <p class="text-left text-1md text-dark-gray">
          Search our database of carriers.
        </p>
        <div class="mt-3 grid grid-cols-12 items-center md:gap-2">
          <div
            class="col-span-6 flex justify-start xs:col-span-4 md:col-span-3"
          >
            <toggle-button
              custom-class="text-1md"
              :items="toggle_items"
              :active-toggle-bg-yellow="true"
              @selected-value="updateCarrierType"
            />
          </div>
          <div
            class="col-span-6 flex flex-col justify-start xs:col-span-8 md:col-span-5"
          >
            <form-field
              id="carrier_number"
              ref="formField"
              :value="form.carrier_number"
              :placeholder="fieldPlaceholder"
              :on-input="onInput"
              name="carrier_number"
              class="text-dark-blue"
              maxlength="8"
              :is-valid="!carrier_number_error"
              error-message="You have entered an invalid DOT or MC number. Please try again."
              :search-icon="true"
            />
          </div>
          <div class="col-span-12 flex md:col-span-4">
            <button-main
              class="max-h-max self-center py-6 text-1md"
              variant="secondary"
              :disabled="!request_launched && !form?.carrier_number"
              :is-loading="loading"
              @click="getCarrier"
            >
              Search
            </button-main>
          </div>
        </div>
        <div v-if="selected_carrier">
          <searched-carrier-card
            :carrier="selected_carrier"
            @delete-search="deleteSearchedCarrier"
          />
        </div>
        <div v-if="!selected_carrier && request_launched && !loading">
          <div class="my-3 rounded-md bg-off-white p-4">
            <small class="text-left text-1md text-body-color">
              Carrier could not be found. Try again.
            </small>
          </div>
        </div>
        <div class="md-mt-0 mt-3 flex justify-end">
          <button-main
            :disabled="carrier_number_error || !selected_carrier"
            @click="handleSubmit"
          >
            Continue
          </button-main>
        </div>
      </div>
    </div>
  </banners>
</template>
<script>
import ButtonMain from '@/components/Button.vue';
import Banners from '@/components/Banners.vue';
import FormField from '@/components/FormField.vue';
import ToggleButton from '@/components/ToggleButton.vue';
import { toastResponse } from '@/common/handleServerResponse';
import SearchedCarrierCard from '@/views/cards/SearchedCarrierCard.vue';

export default {
  name: 'AddCarrier',
  components: {
    Banners,
    FormField,
    ButtonMain,
    ToggleButton,
    SearchedCarrierCard,
  },
  data() {
    return {
      loading: false,
      form: {
        carrier_number: '',
        carrier_type: 'mc',
      },
      selected_carrier: null,
      request_launched: false,
      toggle_items: ['mc', 'dot'],
      carrier_number_error: false,
    };
  },
  computed: {
    fieldPlaceholder() {
      return this.form.carrier_type === 'dot' ? 'Enter DOT #' : 'Enter MC #';
    },
  },
  async created() {},
  methods: {
    updateCarrierType(type) {
      this.form.carrier_type = type;
    },
    onInput(e) {
      const numbers = /^[0-9]+$/;
      this.form.carrier_number = e.target.value;
      if (
        this.form.carrier_number.length &&
        !this.form.carrier_number.match(numbers)
      ) {
        this.carrier_number_error = true;
      } else {
        this.carrier_number_error = false;
      }
    },
    async getCarrier() {
      this.selected_carrier = null;
      this.loading = true;
      try {
        const res = await this.$store.dispatch(
          'carriers/getCarriersByIdentifier',
          {
            is_type: this.form.carrier_type?.toUpperCase(),
            value: this.form.carrier_number,
          }
        );

        if ([200, 201].includes(res.status)) {
          if (res.data) {
            this.selected_carrier = res.data;
          }
        } else if (res.status !== 404) {
          toastResponse(this, res, null);
        }
        this.request_launched = true;
      } catch {
        this.selected_carrier = null;
      } finally {
        this.loading = false;
      }
    },
    deleteSearchedCarrier() {
      this.selected_carrier = null;
      this.request_launched = false;
    },
    async handleSubmit() {
      try {
        const res = await this.$store.dispatch(
          'users/hasCarrierBeenClaimed',
          this.selected_carrier.id
        );
        this.$store.commit('carriers/setMaskedContacts', res?.data);
      } catch {
        this.$store.commit('carriers/setMaskedContacts', []);
      }

      this.$router.push('/dispatcher/request-access');
    },
  },
};
</script>
<style>
.max-h-max {
  height: max-content;
}
</style>
